const React = require('react');
const BaseComponent = require('../shared/base');
const client = require('../../../sdk/client');

var Numeral = require('numeral');
let format = process.env.MONEY_FORMAT;

class PaymentInformation extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            arrPaymentMethods: [],
            credits: {},
            clientID: null,
            lastTotalOrder: null 
        }
    }
    
    componentDidMount() {
        this.getPaymentMethods();

        //Select listener.
        var self = this;
        $("#select-payments").on("change", function () {
            self.updatePaymentGatewaySelected();
            if (
                this.options[this.selectedIndex].innerText == "Transferencia Bancaria" ||
                this.options[this.selectedIndex].innerText == "Pago con Tarjeta"
            ) {
                $("#dissclaimer").show();
            }
            else {
                $("#dissclaimer").hide();
            }

            //Check if the text to display is Pagar or Cotizar
            var textToDisplay = "Pagar";
            if(self.boolPaymentMethodIsCredit() && (!self.boolCreditLineAvailableToPay() || !self.boolCreditAvailable())) {
                textToDisplay = "Cotizar";
            }
            $('#btn-process-payment').text(textToDisplay);
        });

        this.getCreditClient();
    }

    boolPaymentMethodIsCredit()
	{
		let selectorPMethod = document.getElementById('select-payments');
		let selectedPMethod = selectorPMethod.options[selectorPMethod.selectedIndex];
		return selectedPMethod.innerText == "Línea de crédito";
	}

    boolCreditLineAvailableToPay() {
		// available-credit is taken from payment-information.jsx 
        let numTotalOrder = parseFloat($('#calculated-amount-total').text().replace(',',''));
		let boolCreditLineAvailableToPay = false;
        let creditText = $("#available-credit").text();
        var re = new RegExp(",", 'g');
        let availableCredit = parseFloat(creditText.replace(re, ""));
        if (availableCredit >= numTotalOrder) {
            boolCreditLineAvailableToPay = true;
        }
        else {
            boolCreditLineAvailableToPay = false;
        }

        return boolCreditLineAvailableToPay;
    }

    boolCreditAvailable()
	{
		let boolCreditAvailable = false;
		let selector = null;
		if(document.getElementById('span-credit') != null)
		{
			selector = document.getElementById('span-credit').getAttribute('active-credit');
		}

		if(selector != null && selector == "true")
		{
			boolCreditAvailable = true;
		}

		return boolCreditAvailable;
	}

    getCreditClient() {
        const options = {
            userId: this.props.user.ID
        };
        client.Users.getUserDetails(options, function (err, userdetail) {
            //console.log("User in cart")
            //console.log(userdetail)

            var cfUser = userdetail.CustomFields;
            var customerID;
            if(cfUser) {
                cfUser.map(function (cf) {
                    if (cf.Name === process.env.NAME_CF_CLIENTE_ID) {
                        customerID = cf.Values[0];
                    }
                }, this);

                client.CreditInformation.getCreditInformation(customerID)
                .then((response) => {
                    //console.log(response)
                    this.setState({
                        credits: response
                    });
                },
                    (error) => {
                        //    console.log(error);
                    }
                );
            }
        }.bind(this));
    }


    updatePaymentGatewaySelected() {
        var selectedCodePaymentGateway = $('#select-payments').children(':selected').attr('id');
        var selectedPaymentGatewayName = $('#select-payments').children(':selected').text();

        var gatewayObject = {
            Code: selectedCodePaymentGateway,
            Name: selectedPaymentGatewayName
        };

        if (selectedPaymentGatewayName === "Línea de crédito") {
            $('.section-credit').removeClass('hidden');
        } else {
            $('.section-credit').addClass('hidden');
        }

        this.props.paymentCallback(gatewayObject);
    }

    getPaymentMethods() {
        var self = this;
        client.Payments.getPaymentGateways(null, function (err, paymentGateways) {
            if (
                paymentGateways != null && paymentGateways.Records != null && paymentGateways.Records.length > 0
            ) {
                let arrPaymentRecords = [];
                arrPaymentRecords = paymentGateways.Records.filter(payment => payment.Active == true);
                // console.log(arrPaymentRecords);
                self.setState({ "arrPaymentMethods":  arrPaymentRecords});
                self.renderPaymentOptions();
                self.updatePaymentGatewaySelected();
            }
        });
        this.updatePaymentGatewaySelected();
    }

renderPaymentOptions() {
    var selectSelector = $('#select-payments');
    const isB2B = this.isB2BUser(this.props.user.CustomFields);

    const updateOptions = () => {
        const purchaseState = sessionStorage.getItem('purchaseState');
        if (purchaseState === 'paying') {
            return false
        }
        let numTotalOrderText = $('#calculated-amount-total').text();
        let cleanedNumTotalOrderText = numTotalOrderText.replace(/,/g, '');
        let numTotalOrder = parseFloat(cleanedNumTotalOrderText);

         // Check if the total order amount has changed
        if (this.state.lastTotalOrder !== numTotalOrder) {
            this.setState({ lastTotalOrder: numTotalOrder });

            let currentSelection = selectSelector.val(); // Store current selection

            selectSelector.empty(); // Clear existing options

            this.state.arrPaymentMethods.forEach(function (item) {
                if (numTotalOrder < 130000 || item.Gateway !== "Pago con Tarjeta") {
                    if (isB2B && item.Gateway === "Línea de crédito") {
                        selectSelector.append('<option id=' + item.Code + '>' + item.Gateway + '</option>');
                    } else if (item.Gateway !== "Línea de crédito") {
                        selectSelector.append('<option id=' + item.Code + '>' + item.Gateway + '</option>');
                    }
                }
            });

            // Restore previous selection if it's still valid
            if (selectSelector.find(`option[id="${currentSelection}"]`).length > 0) {
                selectSelector.val(currentSelection);
            } else {
                // Set default based on user type and total amount
                if (!isB2B && numTotalOrder < 130000) {
                    selectSelector.val(selectSelector.find('option:contains("Pago con Tarjeta")').val());
                } else if (!isB2B) {
                    selectSelector.val(selectSelector.find('option:contains("Transferencia Bancaria")').val());
                }
            }
        }
    };

    // Initial call to populate options
    updateOptions();

    // Set up an interval to check for changes in numTotalOrder
    setInterval(updateOptions, 2000);
}

    renderCreditAvailable() {

        if (this.state.credits.Message == "Éxito") {
            if (this.state.credits.CurrencyCredits) {
                return this.state.credits.CurrencyCredits.map(function (creditItem, index) {
                    if (this.props.currentCurrency === creditItem.CurrencyCode) {
                        return <label key={index} id="span-credit" active-credit={creditItem.ActiveCredit.toString()}>El saldo disponible de tu línea de crédito es $ <span id="available-credit">{Numeral(creditItem.AvailableCredit).format(format)}</span> <span id="credit-currency">{creditItem.CurrencyCode}</span></label>;
                    }
                }, this);
            } else {
                return <label>Sin línea de crédito</label>;
            }
        } else {
            return <label>Consulta de crédito no disponible</label>;
        }
    }
    isB2BUser(customFields) {
        // Base case: if customFields is not an array or empty
        if (!Array.isArray(customFields) || customFields.length === 0) {
            return false;
        }

        for (let field of customFields) {
            // Check if the current field is the one that determines the user type
            if (field.Name === "Tipo de Usuario" && field.Values[0] === "B2B") {
                return true;
            }

            // If the field has nested custom fields, search them recursively
            if (field.CustomFields) {
                if (isB2BUser(field.CustomFields)) {
                    return true;
                }
            }
        }

        // If no B2B user type is found
        return false;
    }
    render() {
        return (
            <div id="payment-container-cart" className="payment-container">
                <div className="payment-box section-credit">
                    <div>
                        <input type="text" defaultValue="Línea de crédito" disabled></input>
                        {this.renderCreditAvailable()}
                    </div>
                </div>
                <div className="payment-box ">
                    <div className="padding-top">
                        <label className="padding-top">Método de pago</label>
                        <select id="select-payments">
                        </select>
                        <label id="dissclaimer" style={{ display: "none" }}>Al hacer clic en el botón pagar, será redirigido a la página de OpenPay para continuar con la transacción.</label>
                    </div>
                </div>
            </div>
        );
    }
}
module.exports = PaymentInformation;
/*
<option>Netpay</option>
<option>Cash</option>
<option>Crédito</option>
*/